import Loadable from 'react-loadable';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const InvoicesLinksLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "InvoicesLinks" */
      './InvoicesLinks.dynamic'
    ),
  loading: LoadingPageLoadable,
});
